module.exports = __webpack_public_path__ + "img/circulo_celeste_od_64px.5995e037.png";